import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "bodyLogin",
  class: "login-body",
  style: {"background":"getUrlLoginImage() center top / cover no-repeat fixed","transition":"background 1s ease-in-out 0s"}
}
const _hoisted_2 = { class: "mobile-banner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "login-panel" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "login-card"
}
const _hoisted_8 = { class: "login-content" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "username-container" }
const _hoisted_11 = { class: "login-input" }
const _hoisted_12 = {
  key: 0,
  class: "p-error"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "login-input" }
const _hoisted_15 = {
  key: 0,
  class: "p-error"
}
const _hoisted_16 = {
  key: 1,
  class: "password-container"
}
const _hoisted_17 = { class: "login-input" }
const _hoisted_18 = {
  key: 0,
  class: "p-error"
}
const _hoisted_19 = { class: "forgetpassword-container" }
const _hoisted_20 = { style: {"float":"right","font-weight":"bold","padding-bottom":"2px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!
  const _component_Cargando = _resolveComponent("Cargando")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "bottom-right",
      style: {"z-index":"8888888888888"}
    }),
    _createElementVNode("body", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.getLogoPanelUrl,
          alt: "prestige-layout"
        }, null, 8 /* PROPS */, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _ctx.getLogoPanelUrl,
            style: {"width":"80%"},
            alt: "prestige-layout"
          }, null, 8 /* PROPS */, _hoisted_6)
        ])
      ]),
      (!_ctx.isForgetPass)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.handleSubmit(!_ctx.v$.$invalid)), ["prevent"]))
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "top-border" }, null, -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("img", {
                  src: _ctx.getLogoUrl,
                  style: {"width":"100px"}
                }, null, 8 /* PROPS */, _hoisted_9),
                _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Acceso al sistema", -1 /* HOISTED */)),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "Introducir nombre de usuario y contraseña.", -1 /* HOISTED */)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", {
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted })
                  }, "E-mail", 2 /* CLASS */),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_InputText, {
                      ref: "emailControl",
                      placeholder: "Nombre de usuario",
                      autocomplete: "username",
                      modelValue: _ctx.request.email,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.request.email) = $event)),
                      class: _normalizeClass({ 'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted })
                    }, null, 8 /* PROPS */, ["modelValue", "class"])
                  ]),
                  ((_ctx.v$.email.$invalid && _ctx.submitted) || _ctx.v$.email.$pending.$response)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_12, _toDisplayString(_ctx.v$.email.required.$message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                (_ctx.isNeedMFA)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("label", {
                        style: {"color":"brown"},
                        class: _normalizeClass({ 'p-invalid': _ctx.v$.securityCode.$invalid && _ctx.submitted })
                      }, "Código de seguridad", 2 /* CLASS */),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_InputText, {
                          placeholder: "Código de seguridad",
                          modelValue: _ctx.request.securityCode,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.securityCode) = $event)),
                          class: _normalizeClass({ 'p-invalid': _ctx.v$.securityCode.$invalid && _ctx.submitted })
                        }, null, 8 /* PROPS */, ["modelValue", "class"])
                      ]),
                      ((_ctx.v$.securityCode.$invalid && _ctx.submitted) || _ctx.v$.securityCode.$pending.$response)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(_ctx.v$.securityCode.required.$message), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", {
                        class: _normalizeClass({ 'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted })
                      }, "Password", 2 /* CLASS */),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_InputText, {
                          id: "current-password",
                          autocomplete: "current-password",
                          ref: "pwdControl",
                          type: "password",
                          placeholder: "Contraseña",
                          modelValue: _ctx.request.password,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.request.password) = $event)),
                          onKeyup: _withKeys(_ctx.onSubmitLogin, ["enter"]),
                          "toggle-mask": "",
                          class: _normalizeClass(["p-password", { 'p-invalid': _ctx.v$.password.$invalid && _ctx.submitted }])
                        }, null, 8 /* PROPS */, ["modelValue", "onKeyup", "class"]),
                        ((_ctx.v$.password.$invalid && _ctx.submitted) || _ctx.v$.password.$pending.$response)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_18, _toDisplayString(_ctx.v$.password.required.$message), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])
                    ])),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("a", {
                    href: "#",
                    class: "forget-password",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isForgetPass = true))
                  }, "¿Ha olvidado su contraseña?")
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    id: "submitButton",
                    type: "submit",
                    loading: _ctx.showLoading,
                    onClick: _ctx.onSubmitLogin,
                    label: "Acceder"
                  }, null, 8 /* PROPS */, ["loading", "onClick"]),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.version), 1 /* TEXT */)
                ])
              ])
            ], 32 /* NEED_HYDRATION */)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.isForgetPass)
        ? (_openBlock(), _createBlock(_component_ForgotPassword, {
            key: 1,
            isForgetPassChild: _ctx.isForgetPass,
            "onUpdate:isForgetPassChild": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isForgetPass) = $event))
          }, null, 8 /* PROPS */, ["isForgetPassChild"]))
        : _createCommentVNode("v-if", true)
    ], 512 /* NEED_PATCH */),
    _createVNode(_component_Cargando, { ref: "cargando" }, null, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}